export class ConditionSetApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getConditionSet() {
    return this.#http.get('/conditionSet', { params: { includes: 'Condition' } });
  }

  async createConditionSet(body) {
    return this.#http.post('/conditionSet', body);
  }

  async editConditionSet({ conditionSetId, ...body }) {
    return this.#http.put(`/conditionSet/${conditionSetId}`, body);
  }

  async deleteConditionSet({ conditionSetId }) {
    return this.#http.delete(`/conditionSet/${conditionSetId}`);
  }
}
